export enum ModalsFullScreen {
  CROP_IMAGE_MODAL = 'CropImageModalComponent',
  SUBSCRIPTION_REMINDER_MODAL = 'ModalImageComponent',
  TRANSACTION_DETAIL_MODAL = 'TransactionDetailsModalComponent',
  NEW_CREDENTIAL_MODAL = 'NewCredentialModalComponent',
  CONNECT_REMINDER_MODAL = 'ConnectModalImageComponent',
  LANGUAGE = 'LangComponent',
}
